import * as Yup from "yup";
import i18next from "i18next";

export const UpdateProfileSchema = () => Yup.object({

    first_name: Yup.string().required(i18next.t('user.error_fname')),
    last_name: Yup.string().required(i18next.t('user.error_lname')),
    mobile_number: Yup.string()
        .required(i18next.t('user.error_mobile'))
        .matches(/^[0-9]{10}$/, i18next.t('user.error_invalid_mobile')),
    email: Yup.string()
        .required(i18next.t('user.error_email'))
        .email(i18next.t('user.error_invalid_email')),
    country: Yup.string().nullable(),
    state: Yup.string().nullable(),
    city: Yup.string().nullable(),
    pincode: Yup.string()
        .nullable()
        .matches(/^$|^[0-9]{6}$/, i18next.t('user.error_pincode')),
    address: Yup.string().nullable(),
    gender: Yup.string().nullable(),
    dob: Yup.string().nullable(),
    profile: Yup.mixed()
        .test('fileSize', i18next.t('user.error_file_size'), (value) => {
            if (!value) return true;
            return value.size <= 5242880; // 5MB
        })
        .test('fileType', i18next.t('user.error_file_type'), (value) => {
            if (!value) return true;
            return ['image/jpeg', 'image/jpg', 'image/png'].includes(value.type);
        }),

});